import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCircular } from "../Service/Api";
import LazyLoad from "react-lazyload";

const EMagazine = () => {
  useEffect(() => {
    document.title =
      "EMagazine - Mar Gregorios Memorial Hr. Sec. School, Bokaro";
  }, []);

  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthsOfYear = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const handleMonth = (month) => {
    return monthsOfYear[month - 1];
  };

  const emptyArray = [{ title: "Title" }, { title: "Title" }];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const galleryData = await getCircular();

        console.log("Fetched data:", galleryData);

        setData(galleryData);

        const uniqueYears = Array.from(
          new Set(
            galleryData.flatMap((item) => {
              if (item.date) {
                const year = new Date(item.date).getFullYear();
                return [year];
              }

              return [];
            })
          )
        ).sort((a, b) => b - a);

        setYearRanges(uniqueYears);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;
    const monthsSet = new Set();

    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.date) {
          const year = new Date(item.date).getFullYear();

          if (parseInt(selectedYear) === year) {
            const month = new Date(item.date).getMonth() + 1;
            monthsSet.add(month);
            return true;
          }
        }

        return false;
      });
    } else {
      filteredData.forEach((item) => {
        if (item.date) {
          const month = new Date(item.date).getMonth() + 1;
          monthsSet.add(month);
        }
      });
    }

    setAvailableMonths(
      Array.from(monthsSet).sort((a, b) => a - b)
    );

    if (selectedMonth !== "All") {
      filteredData = filteredData.filter((item) => {
        if (item.date) {
          const month = new Date(item.date).getMonth() + 1;
          return parseInt(selectedMonth) === month;
        }

        return false;
      });
    }

    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredData(filteredData);

    console.log("Filtered data:", filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academic</li>
          <li>E-magzine</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">

          {/* Page Heading */}
          <div className="row">
            <div className="col-lg-12">
              <h1>E-magzine</h1>
            </div>
          </div>

          {/* Filters */}
          <div className="row tabs-dynamic">

            {/* Total Count */}
            <div className="col-md-3">
              <div className="count-val">
                <p>Total Count: {filterData.length}</p>
              </div>
            </div>

            {/* Year */}
            <div className="col-md-3">
              <div className="month-selection">
                <select
                  id="yearSelection"
                  onChange={(e) => setSelectedYear(e.target.value)}
                  value={selectedYear}
                >
                  <option value="All">All Years</option>

                  {yearRanges.map((yr, index) => (
                    <option key={index} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Search */}
            <div className="col-md-6">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  autoComplete="off"
                  placeholder="Search Here.."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="clr"></div>

          {/* Magazine List */}
          <div className="row">
            {filterData?.filter(
              (item) => item.category === "Magazine"
            ).length > 0 ? (
              filterData
                .filter((item) => item.category === "Magazine")
                .map((item, index) => {

                  // URL priority:
                  // 1. item.url
                  // 2. attachment URL
                  const magazineUrl = item?.url
                    ? item.url
                    : item?.attachments?.[0]
                    ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                    : "#";

                  // Image URL
                  const imageUrl = item?.images?.[0]
                    ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images[0]}`
                    : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/magzine.png";

                  return (
                    <div
                      key={index}
                      className="col-lg-3 col-md-6 col-sm-6 col-6 fullwidth magzine"
                    >
                      <Link
                        to={magazineUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LazyLoad>
                          <img
                            src={imageUrl}
                            className="img-fluid"
                            alt="Mar Gregorios Memorial Hr. Sec. School, Bokaro"
                          />
                        </LazyLoad>

                        <h4>{item.title}</h4>
                      </Link>
                    </div>
                  );
                })
            ) : (
              emptyArray.map((item, index) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6 col-sm-6 col-6 fullwidth magzine"
                >
                  <Link to="#" target="_blank">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/magzine.png"
                        className="img-fluid"
                        alt="Mar Gregorios Memorial Hr. Sec. School, Bokaro"
                      />
                    </LazyLoad>

                    <h4>{item.title}</h4>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EMagazine;